import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { Router } from '@angular/router';

@Component({
    selector: 'new-template',
    templateUrl: 'new-template.html',
    // styleUrls: ['new-template.css']
})
export class Templateservice {
    name:string;
    qID:string;
    desc: string;
    constructor(private router: Router,
        public dialogRef: MatDialogRef<Templateservice>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.name = this.data.surveyName;
        this.qID = this.data.qID;
        }

        onYes(){

            if(this.name.length!=0)
            {
            this.restApiService.makeTemplate(JSON.stringify(this.data.question),JSON.stringify(this.data.anamoly), JSON.stringify(this.data.cascadeLocation),this.name, this.desc).subscribe(
                result => {
                    this.dialogRef.close(result);
                });
            }
            else{
            this.dialogRef.close({success:false,msg:"Please enter a valid name for the template"});
            }
        }
        onNo(){
            this.dialogRef.close();
        }
}



// WEBPACK FOOTER //
// ./src/app/questionnaires/new-template.ts